import React, {Component} from "react";
//import Footer from "./Footer";
import axios from "axios";

const api = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/adminuser/`
})
class AdminMessages extends Component{

    
    constructor(props) {
        super(props);
        this.state = {
            messages : [],
        }
        this.getMessages();
    }
    
    getMessages = async () => {
        let data = await api.get('/ContactUs/');
        this.setState({messages:data.data})
    }
    
    
    render() {
        return(
            <>
            <br/><br/>
            <div className='ms-5 me-5  mt-5'>
            <h1 style={{display: 'inline'}}><b>User Messages</b></h1>
                <table className="table table-striped table-bordered mt-2">
                <thead>
                    <tr className="table-dark">
                        <th scope="col">Name</th>
                        <th scope="col">Email</th>
                        <th scope="col" className="text-center">Message</th>
                        <th scope="col" className="text-center">Date & Time</th>
                    </tr>
                </thead>
                <tbody>
                {this.state.messages.map(a =>
                <tr key={a.id}>
                    <td width="12%">{a.name}</td> 
                    <td width="10%">{a.email}</td> 
                    <td className="text-center">{a.message}</td>
                    <td width="17%">{a.created_at.slice(12,16)} <span>&nbsp;&nbsp;</span>{a.created_at.slice(0,10)} </td>
                </tr>
                )}
                </tbody>
                </table>
            </div>
           
            
                
            </>
        )
    }
} 
export default AdminMessages;